import { Injectable } from '@angular/core';
import { WebWorkerService as WebWorker } from './web-worker';

@Injectable()
export class WebWorkerService extends WebWorker {}
